module.exports = __webpack_public_path__ + "img/Erectile Dysfunction in Malaysian Men.74d77351.jpg";